var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-container',{attrs:{"show-reset-btn":_vm.isFilterActive,"reset-text":_vm.text.resetButton},on:{"clear":_vm.clear}},[_c('datepicker-range',{ref:"date",attrs:{"name":"date","value":{
        end: _vm.params.to,
        start: _vm.params.from
        }},on:{"change":_vm.onChange}}),_vm._v(" "),_c('tags-filter',{ref:"tags",attrs:{"data":_vm.tags,"name":"tags","title":_vm.text.tags,"show-filter":""},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }